/**
 * 환경 감지 유틸리티
 * 브라우저/WebView/네이티브 앱 환경을 감지하는 중앙화된 함수들
 */

// 브라우저 환경인지 확인
export const isBrowser = (): boolean => {
  return typeof window !== 'undefined';
};

// 네이티브 앱(React Native WebView) 환경인지 확인
export const isNativeApp = (): boolean => {
  if (!isBrowser()) {
    return false;
  }
  const hasWebViewInterface = window.ReactNativeWebView !== undefined;
  const userAgent = navigator.userAgent || '';
  const hasReactNativeUserAgent = userAgent.includes('ReactNative');
  return hasWebViewInterface || hasReactNativeUserAgent;
};

// 순수 웹 브라우저 환경인지 확인 (네이티브 앱 제외)
export const isPureWebBrowser = (): boolean => {
  return isBrowser() && !isNativeApp();
};

// iOS WebView 환경인지 확인
export const isIOSWebView = (): boolean => {
  if (!isNativeApp()) return false;
  const userAgent = navigator.userAgent || '';
  return /iPhone|iPad|iPod/.test(userAgent);
};

// Android WebView 환경인지 확인
export const isAndroidWebView = (): boolean => {
  if (!isNativeApp()) return false;
  const userAgent = navigator.userAgent || '';
  return /Android/.test(userAgent);
};

export type Platform = 'ios' | 'android' | 'web';

// 현재 플랫폼 반환
export const getPlatform = (): Platform => {
  if (isIOSWebView()) return 'ios';
  if (isAndroidWebView()) return 'android';
  return 'web';
};
